__turbopack_context__.v({
  "footer": "index-module__cfaZNq__footer",
  "sectionPrimary": "index-module__cfaZNq__sectionPrimary",
  "sectionSecondary": "index-module__cfaZNq__sectionSecondary",
  "social": "index-module__cfaZNq__social",
});
